import { z } from 'zod';
import {
  EMPTY_FIELD_MESSAGE,
  validateSpace,
  validateTextEn,
} from '@Utils/validation';

enum PRODUCT_INCOME_MODAL_MESSAGE {
  PRODUCT_INCOME = 'กรุณาระบุชื่อสายผลิตภัณฑ์ หรือกลุ่มธุรกิจ',
  PRODUCT_INCOME_EN = 'กรุณาระบุชื่อสายผลิตภัณฑ์ หรือกลุ่มธุรกิจเป็นภาษาอังกฤษ',
}

export const ProductIncomeModalSchema = z.object({
  nameTh: z
    .string({ message: PRODUCT_INCOME_MODAL_MESSAGE.PRODUCT_INCOME })
    .min(1, { message: PRODUCT_INCOME_MODAL_MESSAGE.PRODUCT_INCOME })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  nameEn: z
    .string({ message: PRODUCT_INCOME_MODAL_MESSAGE.PRODUCT_INCOME })
    .min(1, { message: PRODUCT_INCOME_MODAL_MESSAGE.PRODUCT_INCOME })
    .regex(validateTextEn, {
      message: PRODUCT_INCOME_MODAL_MESSAGE.PRODUCT_INCOME_EN,
    })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
});
